/**
 * TeamChips — a user's team memberships as linked chips, capped with a
 * "+N more" overflow indicator. Extracted from `routes/admin/users/index.tsx`
 * (issue #1411).
 */
import { Link } from '@tanstack/react-router';
import type { Team } from '../../graphql/types';

const MAX_VISIBLE_CHIPS = 3;

export function TeamChips({ teams }: { teams: Team[] }): JSX.Element {
  if (teams.length === 0) return <span className="users-team-chips-empty">—</span>;
  const visible = teams.slice(0, MAX_VISIBLE_CHIPS);
  const overflow = teams.length - MAX_VISIBLE_CHIPS;
  return (
    <div className="users-team-chips">
      {visible.map((t) => (
        <Link
          key={t.entityId}
          to="/teams/$teamId"
          params={{ teamId: t.entityId }}
          className="users-team-chip"
          data-testid={`team-chip-${t.entityId}`}
        >
          {t.name}
        </Link>
      ))}
      {overflow > 0 && (
        <span className="users-team-chip-overflow" data-testid="team-chip-overflow">
          +{overflow} more
        </span>
      )}
    </div>
  );
}
